import {PERCENT} from "../Constants/FeeTypes";
import {useEffect, useState} from "react";
import {useMethodData} from "./useMethodData";

export const useFormatFee = (watchPaymentMethod, amount) => {
    const [feeFormatted, setFeeFormatted] = useState(null);
    const [totalAmountFormatted, setTotalAmountFormatted] = useState(null);
    const {currency, fee} = useMethodData(watchPaymentMethod);

    useEffect(() => {
        if (fee) {
            const {type, value} = fee;
            setFeeFormatted(type === PERCENT ? `${value}%` : `${value} ${currency}`);
            if (amount) {
                const totalAmount = type === PERCENT ? parseFloat(amount) + parseFloat(amount) * (parseFloat(value) / 100) :
                    (parseFloat(amount) + parseFloat(value)).toFixed(2);
                setTotalAmountFormatted(`${totalAmount} ${currency}`);
            }
        } else {
            setFeeFormatted(null);
            setTotalAmountFormatted(null);
        }
    }, [watchPaymentMethod, fee, currency, amount]);

    return {feeFormatted, totalAmountFormatted};
}
